/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplyPromotionCodeRequest,
  CartLineItemDeletedEvent,
  CartLineItemModel,
  CreateOrderLineItemRequest,
  EqualOrLesserRewardOptionsResult,
  GetMembershipDetailsResult,
  LastShippingAddress,
  ListCartSummaryParams,
  ProblemDetails,
  RewardPromo,
  SetRepeatCashOnCartRequest,
  SetRepeatCashOnCartResult,
  SetTipOnShopDisplayOrderRequest,
  ShopDisplayOrderResult,
  ShopDisplayOrderSummaryResult,
  UpdateOrderLineItemRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves the current cart summary
 */
export const listCartSummary = (
    params?: ListCartSummaryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderSummaryResult>(
      {url: `/api/v1/orders/current/summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListCartSummaryQueryKey = (params?: ListCartSummaryParams,) => {
    return [
    `/api/v1/orders/current/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCartSummaryQueryOptions = <TData = Awaited<ReturnType<typeof listCartSummary>>, TError = ErrorType<unknown>>(params?: ListCartSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartSummary>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCartSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCartSummary>>> = ({ signal }) => listCartSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCartSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCartSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof listCartSummary>>>
export type ListCartSummaryQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the current cart summary
 */

export function useListCartSummary<TData = Awaited<ReturnType<typeof listCartSummary>>, TError = ErrorType<unknown>>(
 params?: ListCartSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartSummary>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCartSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the price ceiling rather than a priced list: the ceiling depends on which cart units
 * the evaluator would reserve as the qualifying purchase, so it has to come from the discount
 * engine, while the app already has the offer's inclusions and resolves package prices from
 * listings for the requirement picker.
 *
 * The cart is resolved from the caller's claims rather than accepted as a route value, so there
 * is no order id to authorize against a person.
 * @summary Reward options for an "equal or lesser value" Buy X, Get Y offer against the caller's cart.
 */
export const getEqualOrLesserRewardOptionsForCart = (
    discountId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<EqualOrLesserRewardOptionsResult>(
      {url: `/api/v1/orders/current/discounts/${discountId}/equalOrLesserRewardOptions`, method: 'GET', signal
    },
      options);
    }




export const getGetEqualOrLesserRewardOptionsForCartQueryKey = (discountId: string,) => {
    return [
    `/api/v1/orders/current/discounts/${discountId}/equalOrLesserRewardOptions`
    ] as const;
    }


export const getGetEqualOrLesserRewardOptionsForCartQueryOptions = <TData = Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>, TError = ErrorType<unknown>>(discountId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEqualOrLesserRewardOptionsForCartQueryKey(discountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>> = ({ signal }) => getEqualOrLesserRewardOptionsForCart(discountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: discountId !== null && discountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEqualOrLesserRewardOptionsForCartQueryResult = NonNullable<Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>>
export type GetEqualOrLesserRewardOptionsForCartQueryError = ErrorType<unknown>


/**
 * @summary Reward options for an "equal or lesser value" Buy X, Get Y offer against the caller's cart.
 */

export function useGetEqualOrLesserRewardOptionsForCart<TData = Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>, TError = ErrorType<unknown>>(
 discountId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEqualOrLesserRewardOptionsForCart>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEqualOrLesserRewardOptionsForCartQueryOptions(discountId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Displays the Cart
 */
export const listCartDetails = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/details`, method: 'GET', signal
    },
      options);
    }




export const getListCartDetailsQueryKey = () => {
    return [
    `/api/v1/orders/current/details`
    ] as const;
    }


export const getListCartDetailsQueryOptions = <TData = Awaited<ReturnType<typeof listCartDetails>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCartDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCartDetails>>> = ({ signal }) => listCartDetails(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCartDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCartDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof listCartDetails>>>
export type ListCartDetailsQueryError = ErrorType<unknown>


/**
 * @summary Displays the Cart
 */

export function useListCartDetails<TData = Awaited<ReturnType<typeof listCartDetails>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCartDetailsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the reward promo codes available to apply to the current cart
 */
export const availablePromos = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardPromo[]>(
      {url: `/api/v1/orders/current/available-promos`, method: 'GET', signal
    },
      options);
    }




export const getAvailablePromosQueryKey = () => {
    return [
    `/api/v1/orders/current/available-promos`
    ] as const;
    }


export const getAvailablePromosQueryOptions = <TData = Awaited<ReturnType<typeof availablePromos>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof availablePromos>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvailablePromosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof availablePromos>>> = ({ signal }) => availablePromos(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof availablePromos>>, TError, TData> & { queryKey: QueryKey }
}

export type AvailablePromosQueryResult = NonNullable<Awaited<ReturnType<typeof availablePromos>>>
export type AvailablePromosQueryError = ErrorType<unknown>


/**
 * @summary Returns the reward promo codes available to apply to the current cart
 */

export function useAvailablePromos<TData = Awaited<ReturnType<typeof availablePromos>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof availablePromos>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAvailablePromosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Apply RepeatCash to the current Cart
 */
export const setRepeatCashOnCart = (
    setRepeatCashOnCartRequest: SetRepeatCashOnCartRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SetRepeatCashOnCartResult>(
      {url: `/api/v1/orders/current/repeatCash`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setRepeatCashOnCartRequest, signal
    },
      options);
    }




export const getSetRepeatCashOnCartMutationKey = () => ['setRepeatCashOnCart'] as const;

export const getSetRepeatCashOnCartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRepeatCashOnCart>>, TError,SetRepeatCashOnCartMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setRepeatCashOnCart>>, TError,SetRepeatCashOnCartMutationVariables, TContext> => {

const mutationKey = getSetRepeatCashOnCartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRepeatCashOnCart>>, SetRepeatCashOnCartMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setRepeatCashOnCart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetRepeatCashOnCartMutationResult = NonNullable<Awaited<ReturnType<typeof setRepeatCashOnCart>>>
    export type SetRepeatCashOnCartMutationBody = SetRepeatCashOnCartRequest
    export type SetRepeatCashOnCartMutationError = ErrorType<unknown>
    export type SetRepeatCashOnCartMutationVariables = {data: SetRepeatCashOnCartRequest}

    /**
 * @summary Apply RepeatCash to the current Cart
 */
export const useSetRepeatCashOnCart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRepeatCashOnCart>>, TError,SetRepeatCashOnCartMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setRepeatCashOnCart>>,
        TError,
        SetRepeatCashOnCartMutationVariables,
        TContext
      > => {
      return useMutation(getSetRepeatCashOnCartMutationOptions(options));
    }
    /**
 * @summary Set or clear the tip on the current Cart
 */
export const setTipOnCart = (
    setTipOnShopDisplayOrderRequest: SetTipOnShopDisplayOrderRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/tip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setTipOnShopDisplayOrderRequest, signal
    },
      options);
    }




export const getSetTipOnCartMutationKey = () => ['setTipOnCart'] as const;

export const getSetTipOnCartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTipOnCart>>, TError,SetTipOnCartMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setTipOnCart>>, TError,SetTipOnCartMutationVariables, TContext> => {

const mutationKey = getSetTipOnCartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTipOnCart>>, SetTipOnCartMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setTipOnCart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTipOnCartMutationResult = NonNullable<Awaited<ReturnType<typeof setTipOnCart>>>
    export type SetTipOnCartMutationBody = SetTipOnShopDisplayOrderRequest
    export type SetTipOnCartMutationError = ErrorType<unknown>
    export type SetTipOnCartMutationVariables = {data: SetTipOnShopDisplayOrderRequest}

    /**
 * @summary Set or clear the tip on the current Cart
 */
export const useSetTipOnCart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTipOnCart>>, TError,SetTipOnCartMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setTipOnCart>>,
        TError,
        SetTipOnCartMutationVariables,
        TContext
      > => {
      return useMutation(getSetTipOnCartMutationOptions(options));
    }
    /**
 * @summary Apply a PromoCode to the current Cart
 */
export const applyPromotionCode = (
    applyPromotionCodeRequest: ApplyPromotionCodeRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/promoCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyPromotionCodeRequest, signal
    },
      options);
    }




export const getApplyPromotionCodeMutationKey = () => ['applyPromotionCode'] as const;

export const getApplyPromotionCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPromotionCode>>, TError,ApplyPromotionCodeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof applyPromotionCode>>, TError,ApplyPromotionCodeMutationVariables, TContext> => {

const mutationKey = getApplyPromotionCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyPromotionCode>>, ApplyPromotionCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  applyPromotionCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyPromotionCodeMutationResult = NonNullable<Awaited<ReturnType<typeof applyPromotionCode>>>
    export type ApplyPromotionCodeMutationBody = ApplyPromotionCodeRequest
    export type ApplyPromotionCodeMutationError = ErrorType<unknown>
    export type ApplyPromotionCodeMutationVariables = {data: ApplyPromotionCodeRequest}

    /**
 * @summary Apply a PromoCode to the current Cart
 */
export const useApplyPromotionCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPromotionCode>>, TError,ApplyPromotionCodeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyPromotionCode>>,
        TError,
        ApplyPromotionCodeMutationVariables,
        TContext
      > => {
      return useMutation(getApplyPromotionCodeMutationOptions(options));
    }
    /**
 * @summary Remove the PromoCode from the current Cart
 */
export const removePromotionCode = (
    promoCodeId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/promoCode/${promoCodeId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemovePromotionCodeMutationKey = () => ['removePromotionCode'] as const;

export const getRemovePromotionCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePromotionCode>>, TError,RemovePromotionCodeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof removePromotionCode>>, TError,RemovePromotionCodeMutationVariables, TContext> => {

const mutationKey = getRemovePromotionCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePromotionCode>>, RemovePromotionCodeMutationVariables> = (props) => {
          const {promoCodeId} = props ?? {};

          return  removePromotionCode(promoCodeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePromotionCodeMutationResult = NonNullable<Awaited<ReturnType<typeof removePromotionCode>>>

    export type RemovePromotionCodeMutationError = ErrorType<unknown>
    export type RemovePromotionCodeMutationVariables = {promoCodeId: string}

    /**
 * @summary Remove the PromoCode from the current Cart
 */
export const useRemovePromotionCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePromotionCode>>, TError,RemovePromotionCodeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePromotionCode>>,
        TError,
        RemovePromotionCodeMutationVariables,
        TContext
      > => {
      return useMutation(getRemovePromotionCodeMutationOptions(options));
    }
    /**
 * @summary Set a `SalesAssociate` to the current Cart
 */
export const setSalesAssociate = (
    setSalesAssociateBody: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/sales-associate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setSalesAssociateBody, signal
    },
      options);
    }




export const getSetSalesAssociateMutationKey = () => ['setSalesAssociate'] as const;

export const getSetSalesAssociateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSalesAssociate>>, TError,SetSalesAssociateMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setSalesAssociate>>, TError,SetSalesAssociateMutationVariables, TContext> => {

const mutationKey = getSetSalesAssociateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSalesAssociate>>, SetSalesAssociateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSalesAssociate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof setSalesAssociate>>>
    export type SetSalesAssociateMutationBody = string
    export type SetSalesAssociateMutationError = ErrorType<unknown>
    export type SetSalesAssociateMutationVariables = {data: string}

    /**
 * @summary Set a `SalesAssociate` to the current Cart
 */
export const useSetSalesAssociate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSalesAssociate>>, TError,SetSalesAssociateMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSalesAssociate>>,
        TError,
        SetSalesAssociateMutationVariables,
        TContext
      > => {
      return useMutation(getSetSalesAssociateMutationOptions(options));
    }
    /**
 * @summary Set a `SalesAssociate` to the current Cart
 */
export const deleteSalesAssociate = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/sales-associate`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSalesAssociateMutationKey = () => ['deleteSalesAssociate'] as const;

export const getDeleteSalesAssociateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalesAssociate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSalesAssociate>>, TError,void, TContext> => {

const mutationKey = getDeleteSalesAssociateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSalesAssociate>>, void> = () => {


          return  deleteSalesAssociate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSalesAssociate>>>

    export type DeleteSalesAssociateMutationError = ErrorType<unknown>


    /**
 * @summary Set a `SalesAssociate` to the current Cart
 */
export const useDeleteSalesAssociate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSalesAssociate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSalesAssociate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteSalesAssociateMutationOptions(options));
    }
    /**
 * @summary Add Line Items to the current Cart. If no Cart exists, one is created with the provided Line Items
 */
export const createOrderLineItem = (
    createOrderLineItemRequest: CreateOrderLineItemRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/lineitems`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrderLineItemRequest, signal
    },
      options);
    }




export const getCreateOrderLineItemMutationKey = () => ['createOrderLineItem'] as const;

export const getCreateOrderLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderLineItem>>, TError,CreateOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderLineItem>>, TError,CreateOrderLineItemMutationVariables, TContext> => {

const mutationKey = getCreateOrderLineItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderLineItem>>, CreateOrderLineItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOrderLineItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderLineItem>>>
    export type CreateOrderLineItemMutationBody = CreateOrderLineItemRequest
    export type CreateOrderLineItemMutationError = ErrorType<unknown>
    export type CreateOrderLineItemMutationVariables = {data: CreateOrderLineItemRequest}

    /**
 * @summary Add Line Items to the current Cart. If no Cart exists, one is created with the provided Line Items
 */
export const useCreateOrderLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderLineItem>>, TError,CreateOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrderLineItem>>,
        TError,
        CreateOrderLineItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrderLineItemMutationOptions(options));
    }
    /**
 * @summary Returns a view of the line items currently in the user's cart
 */
export const listCartLineItems = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CartLineItemModel[]>(
      {url: `/api/v1/orders/current/lineitems`, method: 'GET', signal
    },
      options);
    }




export const getListCartLineItemsQueryKey = () => {
    return [
    `/api/v1/orders/current/lineitems`
    ] as const;
    }


export const getListCartLineItemsQueryOptions = <TData = Awaited<ReturnType<typeof listCartLineItems>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartLineItems>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCartLineItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCartLineItems>>> = ({ signal }) => listCartLineItems(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCartLineItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCartLineItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listCartLineItems>>>
export type ListCartLineItemsQueryError = ErrorType<unknown>


/**
 * @summary Returns a view of the line items currently in the user's cart
 */

export function useListCartLineItems<TData = Awaited<ReturnType<typeof listCartLineItems>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCartLineItems>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCartLineItemsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Delete the identified line item from the Cart
 */
export const deleteOrderLineItem = (
    shopDisplayOrderLineItemId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CartLineItemDeletedEvent>(
      {url: `/api/v1/orders/current/lineitems/${shopDisplayOrderLineItemId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteOrderLineItemMutationKey = () => ['deleteOrderLineItem'] as const;

export const getDeleteOrderLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderLineItem>>, TError,DeleteOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrderLineItem>>, TError,DeleteOrderLineItemMutationVariables, TContext> => {

const mutationKey = getDeleteOrderLineItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrderLineItem>>, DeleteOrderLineItemMutationVariables> = (props) => {
          const {shopDisplayOrderLineItemId} = props ?? {};

          return  deleteOrderLineItem(shopDisplayOrderLineItemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrderLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrderLineItem>>>

    export type DeleteOrderLineItemMutationError = ErrorType<unknown>
    export type DeleteOrderLineItemMutationVariables = {shopDisplayOrderLineItemId: string}

    /**
 * @summary Delete the identified line item from the Cart
 */
export const useDeleteOrderLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderLineItem>>, TError,DeleteOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrderLineItem>>,
        TError,
        DeleteOrderLineItemMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrderLineItemMutationOptions(options));
    }
    /**
 * @summary Update the identified Line Item in the current Cart. Memberships can't be updated.
 */
export const updateOrderLineItem = (
    shopDisplayOrderLineItemId: string,
    updateOrderLineItemRequest: UpdateOrderLineItemRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShopDisplayOrderResult>(
      {url: `/api/v1/orders/current/lineitems/${shopDisplayOrderLineItemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrderLineItemRequest, signal
    },
      options);
    }




export const getUpdateOrderLineItemMutationKey = () => ['updateOrderLineItem'] as const;

export const getUpdateOrderLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderLineItem>>, TError,UpdateOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderLineItem>>, TError,UpdateOrderLineItemMutationVariables, TContext> => {

const mutationKey = getUpdateOrderLineItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderLineItem>>, UpdateOrderLineItemMutationVariables> = (props) => {
          const {shopDisplayOrderLineItemId,data} = props ?? {};

          return  updateOrderLineItem(shopDisplayOrderLineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderLineItem>>>
    export type UpdateOrderLineItemMutationBody = UpdateOrderLineItemRequest
    export type UpdateOrderLineItemMutationError = ErrorType<unknown>
    export type UpdateOrderLineItemMutationVariables = {shopDisplayOrderLineItemId: string;data: UpdateOrderLineItemRequest}

    /**
 * @summary Update the identified Line Item in the current Cart. Memberships can't be updated.
 */
export const useUpdateOrderLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderLineItem>>, TError,UpdateOrderLineItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderLineItem>>,
        TError,
        UpdateOrderLineItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrderLineItemMutationOptions(options));
    }
    /**
 * @summary Returns an array of membership discount information for the current cart
 */
export const listMembershipDetails = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetMembershipDetailsResult>(
      {url: `/api/v1/orders/current/membership/details`, method: 'GET', signal
    },
      options);
    }




export const getListMembershipDetailsQueryKey = () => {
    return [
    `/api/v1/orders/current/membership/details`
    ] as const;
    }


export const getListMembershipDetailsQueryOptions = <TData = Awaited<ReturnType<typeof listMembershipDetails>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembershipDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembershipDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembershipDetails>>> = ({ signal }) => listMembershipDetails(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembershipDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMembershipDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof listMembershipDetails>>>
export type ListMembershipDetailsQueryError = ErrorType<unknown>


/**
 * @summary Returns an array of membership discount information for the current cart
 */

export function useListMembershipDetails<TData = Awaited<ReturnType<typeof listMembershipDetails>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembershipDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMembershipDetailsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the shipping address used on the user's most recent order
 */
export const getLastShippingAddress = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<LastShippingAddress>(
      {url: `/api/v1/orders/last-shipping-address`, method: 'GET', signal
    },
      options);
    }




export const getGetLastShippingAddressQueryKey = () => {
    return [
    `/api/v1/orders/last-shipping-address`
    ] as const;
    }


export const getGetLastShippingAddressQueryOptions = <TData = Awaited<ReturnType<typeof getLastShippingAddress>>, TError = ErrorType<ProblemDetails>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLastShippingAddress>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastShippingAddressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastShippingAddress>>> = ({ signal }) => getLastShippingAddress(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLastShippingAddress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLastShippingAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getLastShippingAddress>>>
export type GetLastShippingAddressQueryError = ErrorType<ProblemDetails>


/**
 * @summary Returns the shipping address used on the user's most recent order
 */

export function useGetLastShippingAddress<TData = Awaited<ReturnType<typeof getLastShippingAddress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLastShippingAddress>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLastShippingAddressQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






